import getAPIResponse from 'Shared/Utils/Domain/Services/GetAPIResponsePrivateService';

export async function deleteAfterSalesExtra(id) {
  return getAPIResponse(`/v1/after-sales-extras/${id}`, {}, 'DELETE');
}

